import React from 'react';
import { Icon, Loader } from 'semantic-ui-react';
// import 'assets/icons/font/flaticon.css';
import 'assets/fontello/css/fontello.css';
import './IconButton.css';

const classesToApply = {
  select: 'circle outline select-button',
  close: 'flatico-close close-button',
  check: 'flatico-check check-button',
  checked: 'flatico-check-2 check-button',
  cancel: 'flatico-close cancel-button',
  trash: 'flatico-trash trash-button'
}

const IconButton = (props) => {
  const { name, active, loading, className, onClick } = props;
  let classes = classesToApply[name];
  if (active) classes += ' active';
  if (loading) classes += ' progress';
  return (
    <div onClick={onClick} className={`icon-button ${className}`}>
      { loading && <Loader active={true} size='mini'/>}
      <Icon className={classes} />
    </div>
  );
}

IconButton.defaultProps = {
  name: 'select',
  active: false
}

// const Icons = {
//   "flatico-tags": { content: "\f105" },
//   "flatico-close-1": { content: "\f101" },
//   "flatico-close": { content: "\f10a" },
//   "flatico-draw-1": { content: "\f102" },
//   "flatico-draw": { content: "\f106" },
//   "flatico-search": { content: "\f107" },
//   "flatico-add-square-2": { content: "\f103" },
//   "flatico-add-square": { content: "\f108" },
//   "flatico-check-2": { content: "\f100" },
//   "flatico-check": { content: "\f109" },
//   "flatico-add-2": { content: "\f104" },
//   "flatico-add": { content: "\f10b" }
// }

export default IconButton;



// WEBPACK FOOTER //
// ./src/components/IconButtons/index.js